export default __webpack_public_path__ + "static/media/empoweringwomen.4add510d.png";